/**
 * LIORIVE — supplier-link guard for the product description.
 *
 * Some Syncee supplier feeds embed raw HTML in the product description, including links back to
 * the supplier's OWN storefront (e.g. a "care guide" link pointing at the supplier's domain
 * instead of liorive.com). `{{ product.description }}` is rendered as-is by Dawn/main-product.liquid,
 * so that link renders live, clickable, sending customers off LIORIVE to a competing store.
 *
 * This does not touch Shopify product data (never silently edits product records) and does not
 * remove any information — it only defuses navigation to an outside domain by unwrapping the link
 * into plain text, so the sentence still reads normally but no longer leaves the site. The real
 * fix is at the content level (Shopify Admin should replace/remove the sentence); this is a safety
 * net that applies automatically to every product, present or future, without per-product edits.
 */
(function () {
  function guardDescriptionLinks() {
    var containers = document.querySelectorAll('.product__description');
    if (!containers.length) return;

    containers.forEach(function (container) {
      var links = container.querySelectorAll('a[href]');
      links.forEach(function (link) {
        var url;
        try {
          url = new URL(link.href, window.location.href);
        } catch (e) {
          return;
        }
        if (url.hostname && url.hostname !== window.location.hostname) {
          var text = document.createTextNode(link.textContent);
          link.replaceWith(text);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guardDescriptionLinks);
  } else {
    guardDescriptionLinks();
  }
})();
